


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import Button, { ButtonSize } from '@/modules/shared/components/button.component.vue';
import TableComponent, { TableHeader } from '@/modules/shared/components/table.component.vue';

import Purchase from '@/modules/purchase/model/purchase.model';

import currency from '@/modules/shared/filters/currency.filter';
import formatDate from '@/modules/shared/filters/format-date.filter';


@Component({
    components: {
        Button,
        TableComponent,
    },
    computed: {
        ...mapGetters({
            purchaseList: 'getPurchaseList',
        }),
    },
    filters: {
        currency,
        formatDate,
    },
})
export default class PersonalSales extends Vue {
    private purchaseList!: Purchase[];
    private buttonSize = ButtonSize;
    private showBtnLoad = false;
    private headers: TableHeader[] = [
        {
            key: 'reference',
            value: 'Referencia',
        }, {
            key: 'formattedAmount',
            value: 'Importe',
        }, {
            key: 'formattedDate',
            value: 'Cierre',
        }, {
            key: 'points',
            value: 'Puntos',
        }, {
            key: 'note',
            value: 'Observaciones',
            style: 'width: 50%;',
        },
    ];
    private literals = {
        title: 'Ventas personales',
        btnLoad: 'Cargar más',
    };


    private created() {
        this.fetchPurchaseList({ limit: 10 });
    }


    get list() {
        return this.purchaseList.map((purchase: Purchase) => {
            return {
                ...purchase,
                formattedDate: (this.$options.filters as any).formatDate(purchase.dueDate, 'DD/MM/YYYY'),
                formattedAmount: (this.$options.filters as any).currency(purchase.amount, '€'),
            };
        });
    }


    private fetchPurchaseList(params: any = {}) {
        this.$store.dispatch('fetchPurchaseList', params)
            .then((res: any) => {
                this.showBtnLoad = ( res.next !== null );
            });
    }
}
